import { PersonOutlineOutlined, ShoppingBagOutlined, TuneOutlined, AccountBalanceOutlined } from "@mui/icons-material";
import type { AppContext, NavigationItem } from "../../../types";

export const navigations = (context: AppContext | undefined): NavigationItem[] => [
    {
        name: context?.config.sectionHeaders?.account || `My Account`,
        icon: PersonOutlineOutlined,
        path: `/account`,
    },
    {
        name: context?.config.sectionHeaders?.shopping || `Shopping History`,
        icon: ShoppingBagOutlined,
        path: `/account/shopping`,
    },
    {
        name: `Payout History`,
        icon: AccountBalanceOutlined,
        path: `/account/payouts`,
    },
    {
        name: `Preferences`,
        icon: TuneOutlined,
        path: `/account/preferences`,
        liOnly: true,
    },
];
